import Vue from 'vue'
import App from './App.vue'
import router from './router'
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
// import axios from 'axios'
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
// Vue.prototype.$axios = axios;

// import { Button, Form, FormItem, Input, Container, Aside, Menu, Submenu, MenuItemGroup, MenuItem, Header, Breadcrumb, BreadcrumbItem, Main, Row, Col, Table, TableColumn, Pagination, Message, Dropdown } from 'element-ui';
// //
// Vue.use(Button);
// Vue.use(Form);
// Vue.use(FormItem);
// Vue.use(Input);
// Vue.use(Container);
// Vue.use(Aside);
// Vue.use(Menu);
// Vue.use(Submenu);
// Vue.use(MenuItemGroup);
// Vue.use(MenuItem);
// Vue.use(Header);
// Vue.use(Breadcrumb);
// Vue.use(BreadcrumbItem);
// Vue.use(Main);
// Vue.use(Row);
// Vue.use(Col);
// Vue.use(Table);
// Vue.use(TableColumn);
// Vue.use(Pagination);
// Vue.use(Dropdown);
// Vue.prototype.$message = Message


import axios from 'axios'
Vue.prototype.$axios = axios;



Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
